<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="float-right" v-if="!readonly">
          <form-button :indicator="form.processing()" v-on:clicked="submit">
            Save
          </form-button>
        </div>

        <div class="clearfix"></div>
        <hr />

        <div class="row">
          <div class="col-lg-6">
            <selectlist
              name="title"
              v-model="form.title_id"
              :options="titles"
              label="Title"
              placeholder="Please Select"
              helper="Please select the title of the third party"
            ></selectlist>

            <inputbox
              v-model="form.first_name"
              name="first_name"
              label="First Name"
              helper="Please enter the first name of the third party"
            ></inputbox>

            <inputbox
              v-model="form.last_name"
              name="last_name"
              label="Last Name"
              helper="Please enter the last name of the third party"
            ></inputbox>

            <selectlist
              name="gender"
              v-model="form.gender_id"
              :options="genders"
              label="Gender"
              helper="Please select the gender of the third party"
              placeholder="Please Select"
            ></selectlist>

            <toggleswitch
              :labels="true"
              name="contact_details_known"
              v-model="form.contact_details_known"
              helper="If the client knows the contact details of the third party, toggle the switch to 'Yes'"
              label="Does the client know the third party's contact details?"
            ></toggleswitch>

            <div v-show="form.contact_details_known">
              <inputbox
                name="email_address"
                label="Email Address"
                type="email"
                v-model="form.email_address"
                helper="Please enter the email address of the third party"
              ></inputbox>

              <inputbox
                name="telephone"
                label="Telephone"
                v-model="form.telephone"
                helper="Please enter the telephone number of the third party"
              ></inputbox>

              <address-lookup
                :address="address"
                v-on:address="setAddress"
              ></address-lookup>

              <inputbox
                name="how_tp_details_exchanged"
                label="How were the details exchanged?"
                v-model="form.how_tp_details_exchanged"
                helper="How were the third party contact details exchanged?"
              ></inputbox>
            </div>

            <!--        <toggleswitch-->
            <!--          :labels="true"-->
            <!--          name="tp_driver_details_exchanged"-->
            <!--          v-model="form.tp_driver_details_exchanged"-->
            <!--          helper="ThirdParty driver details exchanged?"-->
            <!--          label="Did the client exc?"-->
            <!--        ></toggleswitch>-->

            <!--        <div v-show="form.tp_driver_details_exchanged">-->
            <!--          -->
            <!--        </div>-->

            <toggleswitch
              :labels="true"
              name="tp_insurance_contacted"
              v-model="form.tp_insurance_contacted"
              label="ThirdParty Insurance Company contacted?"
              helper="Have the third-party insurance company or their representative contacted you prior to speaking to us?"
            >
            </toggleswitch>
          </div>
          <div class="col-lg-6">
            <selectlist
              name="insurer"
              :options="insurers"
              v-model="form.insurer_id"
              label="Insurer"
              helper="Please select the insurer for the third party"
              placeholder="Please Select"
              label-name="name"
            ></selectlist>

            <inputbox
              name="insurer_tel"
              type="tel"
              v-model="form.insurer_telephone"
              label="Insurer telephone number"
              helper="Please enter the insurers telephone number"
            ></inputbox>

            <inputbox
              name="gta"
              label="Is GTA?"
              :readonly="true"
              v-model="isGTA"
              helper="Is the insurer GTA or not?"
            ></inputbox>

            <inputbox
              name="protocol"
              label="Has Protocol?"
              :readonly="true"
              v-model="hasProtocol"
              helper="Does the insurer have a protocol?"
            ></inputbox>

            <selectlist
              :options="liabilityStances"
              v-model="form.liability_stance_id"
              name="liability_stance_id"
              label="Liability Stance"
            ></selectlist>

            <inputbox
              name="policy_number"
              label="Policy Number"
              v-model="form.policy_number"
              helper="Please enter the insurance policy number for the third paty"
            ></inputbox>

            <inputbox
              name="claim_number"
              label="Claim Number"
              v-model="form.claim_number"
              helper="If the third party insurer has a claim number, please enter that here"
            ></inputbox>
          </div>
        </div>
      </div>
      <div class="card-footer" v-if="!readonly">
        <div class="float-left">
          <button
            type="button"
            class="btn btn-danger"
            @click="emitRemoveThirdParty"
          >
            Remove Third Party
          </button>
        </div>

        <div class="float-right">
          <form-button :indicator="form.processing()" v-on:clicked="submit">
            Save
          </form-button>
        </div>

        <div class="clearfix"></div>
      </div>
    </fieldset>
  </form>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    thirdParty: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: new window.Form({
        title_id: null,
        first_name: null,
        last_name: null,
        gender_id: null,
        contact_details_known: false,
        email_address: null,
        telephone: null,
        address_details_known: false,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        insurer_id: null,
        liability_stance_id: null,
        policy_number: null,
        claim_number: null,
        insurer_telephone: null,
        tp_driver_details_exchanged: false,
        how_tp_details_exchanged: null,
        tp_insurance_contacted: false
      }),
      has_third_party: false,
      identifier: null,
      data_entered: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    isGTA() {
      if (this.form.insurer_id) {
        let insurer = this.insurers.find(insurer => {
          return insurer.id === parseInt(this.form.insurer_id);
        });

        if (insurer && insurer.gta) {
          return 'Yes';
        }

        return 'No';
      }

      return 'Please Select an Insurer';
    },

    hasProtocol() {
      if (this.form.insurer_id) {
        let insurer = this.insurers.find(insurer => {
          return insurer.id === parseInt(this.form.insurer_id);
        });

        if (insurer && insurer.protocol_tariff) {
          return 'Yes';
        }

        return 'No';
      }

      return 'Please Select an Insurer';
    },

    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    },

    insurers() {
      return this.$store.getters['Insurers/all'];
    },

    liabilityStances() {
      return this.$store.getters['LiabilityStances/all'];
    },

    genders() {
      return this.$store.getters['Genders/all'];
    },

    titles() {
      return this.$store.getters['Titles/all'];
    }
  },

  methods: {
    mount() {
      this.$store.commit('LiabilityStances/retrieve');

      this.has_third_party = this.thirdParty && this.thirdParty.identifier;

      if (this.has_third_party) {
        this.identifier = this.thirdParty.identifier;
        this.form.title_id = this.thirdParty.title_id;
        this.form.first_name = this.thirdParty.first_name;
        this.form.last_name = this.thirdParty.last_name;
        this.form.gender_id = this.thirdParty.gender_id;
        this.form.contact_details_known = this.thirdParty.contact_details_known;
        this.form.email_address = this.thirdParty.email_address;
        this.form.telephone = this.thirdParty.telephone;
        this.form.address_details_known = this.thirdParty.address_details_known;
        this.form.address_line_one = this.thirdParty.address_line_one;
        this.form.address_line_two = this.thirdParty.address_line_two;
        this.form.city = this.thirdParty.city;
        this.form.postcode = this.thirdParty.postcode;
        this.form.insurer_id = this.thirdParty.insurer_id;
        this.form.liability_stance_id = this.thirdParty.liability_stance_id;
        this.form.policy_number = this.thirdParty.policy_number;
        this.form.claim_number = this.thirdParty.claim_number;
        this.form.tp_driver_details_exchanged = this.thirdParty.tp_driver_details_exchanged;
        this.form.how_tp_details_exchanged = this.thirdParty.how_tp_details_exchanged;
        this.form.tp_insurance_contacted = this.thirdParty.tp_insurance_contacted;
      }
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    /**
     * If the user tries to change tab when there are unsaved changes in the form we
     * want to display a popup warning them they have unsaved changes.
     *
     * To do that we add a form @change event listener to the form and then emit an
     * 'unsaved-data' event whenever a form value changes. This is then picked up
     * in the parent component and that handles displaying the warning if the user
     * tries to change tabs.
     */
    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      if (this.readonly) return;
      const method = this.has_third_party ? 'put' : 'post';

      this.form[method](
        `/incidents/${this.incident}/third-parties${
          this.has_third_party ? `/${this.identifier}` : ''
        }`
      )
        .then(response => {
          window.toastify.success(
            'Saved',
            'The third party was saved successfully!'
          );
          // reset monitoring of form changes
          this.data_entered = false;
          this.$emit('unsaved-data', this.data_entered);
          this.$emit('has-third-party', true);
          this.$store.commit('Incident/setThirdParty', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was an error saving the third party'
          );
        });
    },

    emitRemoveThirdParty() {
      this.$emit('remove-third-party');
    }
  },
  watch: {
    $route(to, from) {
      this.mount();
    },
    'form.insurer_id': function(id) {
      let insurer = this.insurers.find(insurer => {
        return insurer.id === parseInt(this.form.insurer_id);
      });

      this.form.insurer_telephone = insurer ? insurer.telephone : null;
    }
  }
};
</script>
